import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  onHamburgerToggle?: (isOpen: boolean) => void;
}

const navItems = [
  { name: '首页', path: '/', icon: 'ri-home-line' },
  { name: '明星黑料', path: '/category/all', icon: 'ri-star-line' },
  { name: '网红吃瓜', path: '/category/all', icon: 'ri-user-smile-line' },
  { name: '每日大赛', path: '/category/all', icon: 'ri-fire-line' },
  { name: '视频爆料', path: '/category/all', icon: 'ri-vidicon-line' },
];

export default function Navbar({ onHamburgerToggle }: NavbarProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleToggle = () => {
    const next = !isMobileOpen;
    setIsMobileOpen(next);
    onHamburgerToggle?.(next);
  };

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <span className="text-background-50 font-heading font-bold text-lg">51</span>
            </span>
            <span className="text-foreground-950 font-heading font-bold text-xl hidden sm:block">
              51爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`px-3 py-2 text-sm font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  isActive(item.path)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className="hidden md:flex items-center gap-1 px-4 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-line w-4 h-4 flex items-center justify-center"></i>
              投稿爆料
            </Link>

            <button
              className="md:hidden p-2 rounded-lg cursor-pointer text-foreground-700 hover:bg-background-200/70 transition-colors"
              onClick={handleToggle}
              aria-label="切换菜单"
            >
              <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {isMobileOpen && (
          <div className="md:hidden border-t border-background-200/70 bg-background-50 animate-fade-in-up">
            <div className="flex flex-col py-3 px-2 gap-1">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={() => setIsMobileOpen(false)}
                  className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 cursor-pointer ${
                    isActive(item.path)
                      ? 'bg-primary-500 text-background-50'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200/70'
                  }`}
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={item.icon}></i>
                  </span>
                  {item.name}
                </Link>
              ))}
              <Link
                to="/about"
                onClick={() => setIsMobileOpen(false)}
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium bg-primary-500 text-background-50 cursor-pointer mt-2"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-send-plane-line"></i>
                </span>
                投稿爆料
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}